import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) { toast.error("Please enter a valid email."); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/subscribers`, { email, brand: "river-stone" });
      toast.success("You're on the list — thank you.");
      setEmail("");
    } catch { toast.error("Something went wrong. Please try again."); }
    finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit} noValidate data-testid="newsletter-form" className="mt-8 max-w-sm">
      <p className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-3">Join our mailing list</p>
      <div className="flex items-center border-b border-white/25 focus-within:border-[#c5a059] transition-colors">
        <input data-testid="newsletter-email" aria-label="Email address" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email" className="flex-1 bg-transparent py-3 text-white placeholder:text-white/30 text-sm font-light focus:outline-none" />
        <button type="submit" data-testid="newsletter-submit" className="text-[#c5a059] hover:translate-x-1 transition-transform p-1" aria-label="Subscribe">
          <ArrowRight size={18} />
        </button>
      </div>
      <p className="text-white/25 text-[11px] font-light mt-2">{loading ? "Subscribing…" : "Specials, events & seasonal features."}</p>
    </form>
  );
};
